module.exports = __webpack_public_path__ + "img/sd.a159f40c.svg";